import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import API from "../axios";
import "../style/request.css";
import ReqApprovals from "./ReqApprovals";

const Request = () => {
  const empDetails = JSON.parse(
    localStorage.getItem("empDetails") || "{}"
  );

  const [filter, setFilter] = useState({
  fromDate: "",
  toDate: ""
});

  const [hods, setHods] = useState([]);
  const [activeTab, setActiveTab] =
    useState("new");

  const [loading, setLoading] =
    useState(false);

    const [showModal, setShowModal] =
  useState(false);

    const [selectedRequest, setSelectedRequest] =
      useState(null);

  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "success"
  });

  const [requestData, setRequestData] =
    useState([]);

  const [form, setForm] = useState({
    requestType: "ON DUTY",
    fromDate: "",
    toDate: "",
    noOfDays: "",
    hod: "",
    hodid: "",
    remarks: "",

    // EXTRA DUTY
    fromTime: "",
    toTime: "",

    // MISSED SWIPE
    swipeType: ""
  });

  // TOAST
  const showToast = (
    message,
    type = "success"
  ) => {
    setToast({
      show: true,
      message,
      type
    });

    setTimeout(() => {
      setToast((prev) => ({
        ...prev,
        show: false
      }));
    }, 3000);
  };

  // FETCH HODS
  const fetchHods = async () => {
    try {
      const res = await API.post("/hods", {
        dept: empDetails.department,
        empcode : empDetails.employee_code
      });

      setHods(res.data);

      // AUTO SELECT FIRST HOD
      if (res.data.length > 0) {
        setForm((prev) => ({
          ...prev,
          hod: res.data[0].empname,
          hodid: res.data[0].empid
        }));
      }
    } catch (err) {
      console.log(err);

      showToast(
        "Failed to load HODs",
        "error"
      );
    }
  };

  useEffect(() => {
    fetchHods();
  }, []);

  // DAYS CALCULATION
  useEffect(() => {
    if (form.fromDate && form.toDate) {
      const from = new Date(form.fromDate);
      const to = new Date(form.toDate);

      const diff =
        Math.ceil(
          (to - from) /
            (1000 * 60 * 60 * 24)
        ) + 1;

      setForm((prev) => ({
        ...prev,
        noOfDays: diff > 0 ? diff : 0
      }));
    }
  }, [form.fromDate, form.toDate]);

  // FETCH MY REQUESTS
 const fetchRequests = async (
      fromDate = "",
      toDate = ""
    ) => {
      try {
        setLoading(true);

        const res = await API.post(
          "/my-requests",
          {
            empcode:
              empDetails.employee_code,
            fromDate,
            toDate
          }
        );

        setRequestData(res.data);
      } catch (err) {
        console.log(err);

        showToast(
          "Failed to fetch requests",
          "error"
        );
      } finally {
        setLoading(false);
      }
    };

 useEffect(() => {
  if (activeTab === "my") {
    fetchRequests();
  }
}, [activeTab]);

  // SUBMIT
  const handleSubmit = async () => {
    if (
      !form.requestType ||
      !form.fromDate ||
      !form.toDate ||
      !form.hod ||
      !form.remarks
    ) {
      showToast(
        "Please fill all fields",
        "error"
      );

      return;
    }

    // EXTRA DUTY VALIDATION
    if (
      form.requestType ===
        "EXTRA DUTY" &&
      (!form.fromTime || !form.toTime)
    ) {
      showToast(
        "Please select time",
        "error"
      );

      return;
    }

    // MISSED SWIPE VALIDATION
      if (
        form.requestType === "MISSED SWIPE" &&
        !form.swipeType
      ) {
        showToast(
          "Please select swipe type",
          "error"
        );

        return;
      }

      console.log("form : ", form);


    try {
      setLoading(true);

        const response = await API.post("/request", {
        empid: empDetails.employee_code,
        empname: empDetails.emp_name,
        empBranch: empDetails.branchname,
        department:
          empDetails.department,
        ...form
      });

      
      showToast(
        response.data.message,
        response.data.type        
      );

      setForm({
        requestType: "ON DUTY",
        fromDate: "",
        toDate: "",
        noOfDays: "",
        // hod:
        //   hods.length > 0
        //     ? hods[0].empid
        //     : "",
        remarks: "",
        hod: hods.length > 0 ? hods[0].empname : "",
        hodid: hods.length > 0 ? hods[0].empid : "",
        fromTime: "",
        toTime: "",
        swipeType: ""
      });
    } catch (err) {
      console.log(err);

      showToast(
        "Failed to submit request",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

 

  return (
    // <div className="container mt-lg-3 ">
    <div className="container-fluid container-lg mt-3 mb-5 mb-lg-0 pt-lg-5">
      {/* TOAST */}
      {toast.show && (
        <div
          className={`custom-toast ${toast.type}`}
        >
          {toast.message}
        </div>
      )}

      {/* LOADER */}
      {loading && (
        <div className="page-loader-request">
          <div className="loader"></div>
        </div>
      )}

      {/* HEADER */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-4"
      >
        <h2 className="request-title">
          Request Portal
        </h2>

        {/* <div className="request-tabs">
          <button
            className={`tab-btn ${
              activeTab === "new"
                ? "active-tab"
                : ""
            }`}
            onClick={() =>
              setActiveTab("new")
            }
          >
            New Request
          </button>

          <button
            className={`tab-btn ${
              activeTab === "my"
                ? "active-tab"
                : ""
            }`}
            onClick={() =>
              setActiveTab("my")
            }
          >
            My Requests
          </button>
        </div> */}

        <div className="request-tabs">
            <button
              className={`tab-btn ${
                activeTab === "new"
                  ? "active-tab"
                  : ""
              }`}
              onClick={() =>
                setActiveTab("new")
              }
            >
              New Request
            </button>

            <button
              className={`tab-btn ${
                activeTab === "my"
                  ? "active-tab"
                  : ""
              }`}
              onClick={() =>
                setActiveTab("my")
              }
            >
              My Requests
            </button>

            {/* ONLY HOD */}
            {empDetails.hod === "y" && (
              <button
                className={`tab-btn ${
                  activeTab === "approvals"
                    ? "active-tab"
                    : ""
                }`}
                onClick={() =>
                  setActiveTab("approvals")
                }
              >
                Approvals
              </button>
            )}
          </div>

      </motion.div>

      {/* NEW REQUEST */}
      {activeTab === "new" && (
        <motion.div
          className="request-card"
          initial={{
            opacity: 0,
            y: 20
          }}
          animate={{
            opacity: 1,
            y: 0
          }}
        >
          <div className="row g-3">
            {/* REQUEST TYPE */}
            <div className="col-md-6">
              <label>
                Request Type
              </label>

              <select
                className="form-control"
                value={form.requestType}
                onChange={(e) =>
                  setForm({
                    ...form,
                    requestType:
                      e.target.value
                  })
                }
              >
                <option value="ON DUTY">
                  ON DUTY
                </option>

                <option value="EXTRA DUTY">
                  EXTRA DUTY
                </option>

                <option value="MISSED SWIPE">
                  MISSED SWIPE
                </option>

                {/* <option value="OFFICIAL PERMISSION">
                  OFFICIAL PERMISSION
                </option> */}

              </select>
            </div>

            {/* HOD */}
            <div className="col-md-6">
                <label>HOD</label>

                <select
                  className="form-control"
                  value={form.hodid}
                  onChange={(e) => {

                    const selectedHod = hods.find(
                      (item) => item.empid === e.target.value
                    );

                    setForm({
                      ...form,
                      hod: selectedHod?.empname || "",
                      hodid: selectedHod?.empid || ""
                    });
                  }}
                >
                  <option value="">Select HOD</option>

                  {hods.map((item) => (
                    <option
                      key={item.empid}
                      value={item.empid}
                    >
                      {item.empname}
                    </option>
                  ))}
                </select>
              </div>

            {/* FROM DATE */}
            <div className="col-md-6">
              <label>
                From Date
              </label>

              <input
                type="date"
                className="form-control"
                value={form.fromDate}
                onChange={(e) =>
                  setForm({
                    ...form,
                    fromDate:
                      e.target.value
                  })
                }
              />
            </div>

            {/* TO DATE */}
            <div className="col-md-6">
              <label>
                To Date
              </label>

              <input
                type="date"
                className="form-control"
                value={form.toDate}
                onChange={(e) =>
                  setForm({
                    ...form,
                    toDate:
                      e.target.value
                  })
                }
              />
            </div>

            {/* NO OF DAYS */}
            <div className="col-md-6">
              <label>
                No Of Days
              </label>

              <input
                type="text"
                className="form-control"
                value={form.noOfDays}
                onChange={(e) =>
                  setForm({
                    ...form,
                    noOfDays:
                      e.target.value
                  })
                }
              />
            </div>

            {/* EXTRA DUTY */}
            {(form.requestType === "EXTRA DUTY" ||
              form.requestType === "OFFICIAL PERMISSION" )  && (
              <motion.div
                initial={{
                  opacity: 0,
                  y: 10
                }}
                animate={{
                  opacity: 1,
                  y: 0
                }}
                className="row g-3"
              >
                <div className="col-md-6">
                  <label>
                    From Time
                  </label>

                  <input
                    type="time"
                    className="form-control"
                    value={
                      form.fromTime
                    }
                    onChange={(e) =>
                      setForm({
                        ...form,
                        fromTime:
                          e.target
                            .value
                      })
                    }
                  />
                </div>

                <div className="col-md-6">
                  <label>
                    To Time
                  </label>

                  <input
                    type="time"
                    className="form-control"
                    value={form.toTime}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        toTime:
                          e.target
                            .value
                      })
                    }
                  />
                </div>
              </motion.div>
            )}

            {/* MISSED SWIPE */}
            {form.requestType ===
              "MISSED SWIPE" && (
              <motion.div
                initial={{
                  opacity: 0,
                  y: 10
                }}
                animate={{
                  opacity: 1,
                  y: 0
                }}
                className=""
              >
                <label className="mb-2 d-block">
                  Swipe Type
                </label>

                <div className="d-flex gap-4">
                  <div>
                    <input
                      type="radio"
                      id="morning"
                      name="swipeType"
                      value="MORNING"
                      checked={
                        form.swipeType ===
                        "MORNING"
                      }
                      onChange={(e) =>
                        setForm({
                          ...form,
                          swipeType:
                            e.target
                              .value
                        })
                      }
                    />

                    <label
                      htmlFor="morning"
                      className="ms-2"
                    >
                      Morning
                    </label>
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="evening"
                      name="swipeType"
                      value="EVENING"
                      checked={
                        form.swipeType ===
                        "EVENING"
                      }
                      onChange={(e) =>
                        setForm({
                          ...form,
                          swipeType:
                            e.target
                              .value
                        })
                      }
                    />

                    <label
                      htmlFor="evening"
                      className="ms-2"
                    >
                      Evening
                    </label>
                  </div>
                </div>
              </motion.div>
            )}

            {/* REMARKS */}
            <div className="col-12">
              <label>
                Remarks
              </label>

              <textarea
                className="form-control"
                rows="4"
                placeholder="Enter remarks"
                value={form.remarks}
                onChange={(e) =>
                  setForm({
                    ...form,
                    remarks:
                      e.target.value
                  })
                }
              ></textarea>
            </div>

            {/* SUBMIT */}
            <div className="col-12 text-center mt-3">
              <button
                className="submit-bn btn btn-sm btn-dark rounded-5 px-5 py-2"
                onClick={handleSubmit}
              >
                Submit Request
              </button>
            </div>
          </div>
        </motion.div>
      )}

      {/* MY REQUESTS */}

      {activeTab === "my" && (

        <>

            <div className="row mb-3 filter-box">
                <div className="col-lg-2 col-3">
                  <input
                    type="date"
                    className="form-control filterinp"
                    value={filter.fromDate}
                    onChange={(e) =>
                      setFilter({
                        ...filter,
                        fromDate: e.target.value
                      })
                    }
                  />
                </div>

                <div className="col-lg-2 col-3  mt-md-0">
                  <input
                    type="date"
                    className="form-control filterinp"
                    value={filter.toDate}
                    onChange={(e) =>
                      setFilter({
                        ...filter,
                        toDate: e.target.value
                      })
                    }
                  />
                </div>

                <div className="col-lg-2 col-3 mt-md-0">
                  <button
                    className="submit-btn w-100 filterinp"
                    onClick={() =>
                      fetchRequests(
                        filter.fromDate,
                        filter.toDate
                      )
                    }
                  >
                    Filter
                  </button>
                </div>
              </div>

               <motion.div
                  className="table-responsive request-table-card "
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                >
                  <table className="table table-bordered align-middle">
                    <thead>
                      <tr className="text-center">
                        <th>Employee</th>
                        <th>Day</th>
                        <th>Req Type</th>
                        <th>Date</th>
                        <th>Status</th>                        
                        <th>View</th>
                      </tr>
                    </thead>

                    <tbody>
                      {requestData.length > 0 ? (
                        requestData.map(
                          (item, index) => (
                            <tr key={index} className="text-center">
                              <td>
                                {item.empname} - {item.empid}
                              </td>                              
                              <td>
                                {
                                  item.NoOfdays
                                }
                              </td>
                              <td>
                                {
                                  item.formType
                                }
                              </td>
                              <td>
                                {new Date(item.appliedFromDate).toLocaleDateString("en-GB")} - {new Date(item.appliedToDate).toLocaleDateString("en-GB")}
  

                                {/* {item.appliedFromDate} - {item.appliedToDate} */}
                              </td>
                               <td>                                
                                  {item.status == 0 ? "Pending" : "Approved"}                                
                              </td>

                              <td>
                                <button
                                    className="btn btn-sm btn-dark"
                                    onClick={() => {
                                      setSelectedRequest(item);
                                      setShowModal(true);
                                    }}
                                  >
                                    More Details
                                  </button>
                              </td>
                            </tr>
                          )
                        )
                      ) : (
                        <tr>
                          <td
                            colSpan="6"
                            className="text-center"
                          >
                            No Requests Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </motion.div>
        </>
       

       
      )}

      {/* APPROVALS */}
      {activeTab === "approvals" &&
        empDetails.hod === "y" && (
          <ReqApprovals />
      )}

      {/* DETAILS MODAL */}
{showModal && selectedRequest && (
  <div className="custom-modal-overlay">
    <motion.div
      className="custom-modal-box"
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
    >
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="m-0">
          Request Details
        </h4>

        <button
          className="btn btn-sm btn-danger"
          onClick={() =>
            setShowModal(false)
          }
        >
          ✕
        </button>
      </div>

      <div className="request-detail-grid">

        <div>
          <strong>Employee</strong>
          <p>
            {selectedRequest.empname} - {selectedRequest.empid}
          </p>
        </div>

        <div>
          <strong>Request Type</strong>
          <p>
            {selectedRequest.formType}
          </p>
        </div>

        <div>
          <strong>No Of Days</strong>
          <p>
            {selectedRequest.NoOfdays}
          </p>
        </div>

        <div>
          <strong>From Date</strong>
          <p>
            {new Date(
              selectedRequest.appliedFromDate
            ).toLocaleDateString(
              "en-GB"
            )}
          </p>
        </div>

        <div>
          <strong>To Date</strong>
          <p>
            {new Date(
              selectedRequest.appliedToDate
            ).toLocaleDateString(
              "en-GB"
            )}
          </p>
        </div>

          <div>
            <strong>Missed Swipe</strong>
            <p>
              {selectedRequest.SwipeDetils == '' ? "-" : selectedRequest.SwipeDetils}
            </p>
          </div>
          <div>
            <strong>Extra Duty Timing</strong>
            <p>
              {selectedRequest.ExtraDuty_timings ||
                "-"}
            </p>
          </div>

        <div>
          <strong>Status</strong>
          <p>
            {selectedRequest.status == 0
              ? "Pending"
              : "Approved"}
          </p>
        </div>

        <div>
          <strong>Approved By</strong>
          <p>
            {selectedRequest.approvedBy ||
              "-"}
          </p>
        </div>

        <div>
          <strong>Approved Date</strong>
          <p>

            { selectedRequest.approvedDate ? new Date(
              selectedRequest.approvedDate
            ).toLocaleDateString(
              "en-GB"
            ) : "-"}
          </p>
        </div>



        <div className="w-100">
          <strong>Remarks</strong>
          <p>
            {selectedRequest.remarks ||
              "-"}
          </p>
        </div>

      </div>

      {/* <div className="text-end mt-4">
        <button
          className="btn btn-secondary"
          onClick={() =>
            setShowModal(false)
          }
        >
          Close
        </button>
      </div> */}
    </motion.div>
  </div>
)}

    </div>
  );
};

export default Request;